export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str);
      if (str.indexOf('{') > -1) { return true; }
      return false;
    } catch (e) {
      console.log(e); return false;
    }
  }
  return false;
}
export function formatNumberToPercent(num, rounding) {
  const number = (num * 100).toFixed(rounding);
  if ((number - Math.floor(number)) > 0) {
    return `${number}%`;
  }
  return `${Math.floor(number)}%`;
}

export function formatRoundToTwo(num) {
  return +(`${Math.round(`${num}e+2`)}e-2`);
}

export function createAndDownloadCSVFile(exportContent, filename) {
  const blob = new Blob([exportContent], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    const blob = new Blob([exportContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);

    link.download = filename;
    link.click();
  }
}

/* eslint-disable no-bitwise */
/* eslint-disable no-mixed-operators */
export function generateUUID() {
  let d = Date.now();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

export function validURL(str) {
  const pattern = new RegExp(/^https?:\/\/\S+?\.\S+$/mgi); // fragment locator
  return !!pattern.test(str);
}

export function validHttpsURL(str) {
  const pattern = new RegExp(/^https:\/\/\S+?\.\S+$/mgi); // fragment locator
  return !!pattern.test(str);
}

export function groupBy(list, key) {
  return list.reduce((groups, item) => {
    const val = item[key];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups;
  }, {});
}

export function isNumber(value) {
  const pattern = new RegExp(/^\d+$/mg);
  return !!pattern.test(value);
}

export async function getThumbnailForVideo(videoUrl) {
  const video = document.createElement('video');
  const canvas = document.createElement('canvas');
  video.style.display = 'none';
  canvas.style.display = 'none';

  // Trigger video load
  await new Promise((resolve, reject) => {
    video.addEventListener('loadedmetadata', () => {
      video.width = video.videoWidth;
      video.height = video.videoHeight;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      video.currentTime = 0;
    });
    video.addEventListener('seeked', () => resolve());
    video.src = videoUrl;
  });

  // Draw the thumbnails
  canvas
    .getContext('2d')
    .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  const imageUrl = canvas.toDataURL('image/png');
  return imageUrl;
}

export function base64ToBlob(base64Data) {
  const dataArr = base64Data.split(',');

  const imageType = dataArr[0].match(/:(.*?);/)[1]; // 獲取文件類型

  const textData = window.atob(dataArr[1]); // 使用atob() 將base64 轉為文本文件
  const arrayBuffer = new ArrayBuffer(textData.length);// 定義一段固定大小記憶體區塊，用來儲存 raw binary data
  const uint8Array = new Uint8Array(arrayBuffer);// 定義這個 arrayBuffer 儲存固定型別資料（Uint8Array）

  for (let i = 0; i < textData.length; i++) {
    uint8Array[i] = textData.charCodeAt(i);// 將文本文件轉為UTF-16的ASCII, 放到 uint8Array 中
  }

  return new Blob([arrayBuffer], { type: imageType });
}
